import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import CheckCircleOutlinedIcon from "@mui/icons-material/CheckCircleOutlined";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import ReportProblemOutlinedIcon from "@mui/icons-material/ReportProblemOutlined";
import React from "react";
import separate from "../separate/separate";


const setIcon=(type)=> {
    if (type === "info") {
        return <ErrorOutlineOutlinedIcon
            className="IconNotification"
            style={
                {
                    color: "#42b5f0",
                }
            }
        />
    } else if (type === "success") {
        return <CheckCircleOutlinedIcon
            className="IconNotification"
            style={
                {
                    color: "#6af042",
                }
            }
        />
    } else if (type === "error") {
        return <CancelOutlinedIcon
            className="IconNotification"
            style={
                {
                    color: "#ed3237",
                }
            }
        />
    } else if (type === "warning") {
        return <ReportProblemOutlinedIcon
            className="IconNotification"
            style={
                {
                    color: "#f0ad42",
                }
            }
        />
    }
};

export default setIcon